import { useArchive } from '../utils/archive';

// ---------------------------------------------------------------------------
// ArchiveBanner — "you are looking at a frozen copy" (21 Sep 2026).
//
// FOOM 2026 stays online as a read-only second instance of this same app
// (server FOOM_READ_ONLY=1, see server/utils/readOnly.js) while FOOM 2027 runs
// on the live site. The two look identical, so the archive must say what it is
// on EVERY page, the login page included — which is why this asks a public
// endpoint and sits above the router's pages rather than in a header.
//
// On the live site GET /api/archive answers { read_only: false } and this
// renders nothing. Against an older server with no such route the SPA
// catch-all returns HTML, read_only is undefined, and it still renders
// nothing — so the client can be deployed ahead of a server restart.
// ---------------------------------------------------------------------------
export default function ArchiveBanner() {
  const info = useArchive();

  if (!info) return null;

  return (
    <div className="c-archive-banner" role="status">
      <strong>{info.label}</strong>
      <span>
        {' '}— a frozen, read-only copy of the competition as it finished. Nothing here can be changed.
        {info.live_url && (
          <> The live site is <a href={info.live_url}>{info.live_url.replace(/^https?:\/\//, '')}</a>.</>
        )}
      </span>
    </div>
  );
}
